import { defineMessages } from '@/i18n'

/** Карточка «идёт проверка» статьи во вкладке «Доступ» — тексты в духе курса. */
export const reviewMessages = defineMessages({
  ru: {
    reviewingArticleTitle: 'Проверяем статью',
    reviewingUpdateTitle: 'Проверяем обновление',
    reviewingArticleBody: 'Редактирование вернётся после решения.',
    reviewingUpdateBody:
      'Читатели пока видят прежнюю версию. Редактирование вернётся после решения.',
    withdraw: 'Отозвать заявку',
  },
  en: {
    reviewingArticleTitle: 'Reviewing your article',
    reviewingUpdateTitle: 'Reviewing your update',
    reviewingArticleBody: 'You can edit it again once the review is done.',
    reviewingUpdateBody:
      'Readers still see the previous version. You can edit it again once the review is done.',
    withdraw: 'Withdraw from review',
  },
})
